import { onPage } from './app/lifecycle'
import { getState } from './app/store'

/**
 * Page background: one image picked at random from the page's list on every
 * visit (pages come from WP Super Cache, so the pick can't happen in PHP).
 * The layer sits outside #swup and crossfades between pictures; the list is
 * read from the JSON the new page ships inside #swup (see header.php).
 */
const FADE_MS = 1200

let current = null

const readBackgrounds = (root) => {
  const data = root.querySelector('[data-page-backgrounds]')
  try {
    const list = JSON.parse(data?.textContent || '[]')
    return Array.isArray(list) ? list : []
  } catch {
    return []
  }
}

// Random, but never the picture that is already showing.
const pick = (list) => {
  if (list.length <= 1) return list[0] ?? null
  const others = list.filter((background) => background.src !== current?.src)
  return others[Math.floor(Math.random() * others.length)]
}

function clear(layer) {
  current = null
  layer.querySelectorAll('.page-background-image').forEach((image) => {
    image.classList.remove('is-visible')
    window.setTimeout(() => image.remove(), FADE_MS)
  })
}

function show(layer, background) {
  if (background.src === current?.src) return
  current = background

  const image = new Image()
  image.className = 'page-background-image'
  image.alt = ''
  image.decoding = 'async'
  image.sizes = '100vw'
  image.srcset = background.srcset
  image.src = background.src
  image.style.objectPosition = background.position

  image
    .decode()
    .catch(() => {})
    .then(() => {
      // A later visit already asked for another picture.
      if (current !== background) return

      const previous = [...layer.querySelectorAll('.page-background-image')]
      layer.classList.toggle('is-unstyled', !background.styled)
      layer.append(image)
      requestAnimationFrame(() => image.classList.add('is-visible'))
      window.setTimeout(() => previous.forEach((old) => old.remove()), FADE_MS)
    })
}

onPage((root) => {
  const layer = document.querySelector('[data-background]')
  // Easy mode shows no photos — don't download them either.
  if (!layer || getState().easyMode) return

  const background = pick(readBackgrounds(root))
  if (background) {
    show(layer, background)
  } else {
    clear(layer)
  }
})
